import { render } from "./CartModalButton.vue?vue&type=template&id=d46a0a30&scoped=true"
import script from "./CartModalButton.vue?vue&type=script&lang=js"
export * from "./CartModalButton.vue?vue&type=script&lang=js"

import "./CartModalButton.vue?vue&type=style&index=0&id=d46a0a30&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46a0a30"]])

export default __exports__